import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ChevronRight } from 'lucide-react';

const LEFT_IMAGE = "https://customer-assets.emergentagent.com/job_d8bf1b61-a9b7-4610-b686-61792bda2646/artifacts/qbwrqz5f_helmetandpom4.jpg";
const RIGHT_IMAGE = "https://customer-assets.emergentagent.com/job_d8bf1b61-a9b7-4610-b686-61792bda2646/artifacts/0yp8rjwz_DSC_3267.jpg";

const CoverPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleEnter = () => {
    if (user) {
      navigate('/home');
    } else {
      navigate('/guest');
    }
  };

  return (
    <div className="h-screen w-screen bg-[#060e1b] flex overflow-hidden" data-testid="cover-page">
      {/* Left Image Panel */}
      <div className="hidden lg:block w-[28%] h-full relative">
        <img 
          src={LEFT_IMAGE}
          alt="Park City Chiefs Team"
          className="w-full h-full object-cover"
          data-testid="cover-left-image"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0a1628]/80" />
      </div>

      {/* Center Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 sm:px-12 relative z-10">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img 
            src="https://customer-assets.emergentagent.com/job_d8bf1b61-a9b7-4610-b686-61792bda2646/artifacts/qv0rja6a_image.png" 
            alt="Park City Chiefs"
            className="h-28 sm:h-36 mx-auto drop-shadow-2xl"
            data-testid="cover-logo"
          />
        </div>

        {/* THE TRIBE STANDARD */}
        <div className="text-center mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            <span className="text-white">THE TRIBE </span>
            <span className="text-red">STANDARD</span>
          </h1>
        </div>

        {/* Slogan Lines */}
        <div className="text-center space-y-5 max-w-2xl mb-12">
          <p 
            className="text-white text-lg sm:text-xl lg:text-2xl font-light tracking-wide animate-fade-in-up"
            style={{ animationDelay: '0.4s' }}
          >
            More than a league, <span className="font-semibold">WE</span> are family.
          </p>
          <p 
            className="text-white text-lg sm:text-xl lg:text-2xl font-light tracking-wide animate-fade-in-up"
            style={{ animationDelay: '0.6s' }}
          >
            Structure. Mentorship. Academic accountability.
          </p>
          <p 
            className="text-white text-lg sm:text-xl lg:text-2xl font-light tracking-wide animate-fade-in-up"
            style={{ animationDelay: '0.8s' }}
          >
            Where development comes before everything else.
          </p>
        </div>

        {/* Join The Tribe. Build the Future. */}
        <div 
          className="text-center mb-14 animate-fade-in-up"
          style={{ animationDelay: '1s' }}
        >
          <p className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            <span className="text-white">Join The Tribe. </span>
            <span className="text-gold">Build the Future.</span>
          </p>
        </div>

        {/* Enter Button */}
        <div 
          className="animate-fade-in-up"
          style={{ animationDelay: '1.2s' }}
        >
          <button
            onClick={handleEnter}
            className="group relative px-10 py-4 bg-red text-white text-lg font-bold uppercase tracking-widest rounded-sm overflow-hidden transition-all duration-300 hover:bg-red/90 hover:tracking-[0.2em] hover:shadow-[0_0_30px_rgba(200,16,46,0.4)]"
            data-testid="cover-enter-btn"
          >
            <span className="relative z-10 flex items-center gap-2">
              Enter
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
        </div>

        {/* Subtle footer */}
        <p 
          className="absolute bottom-6 text-white/20 text-xs tracking-widest uppercase animate-fade-in"
          style={{ animationDelay: '1.5s' }}
        >
          Park City Chiefs Youth Football
        </p>
      </div>

      {/* Right Image Panel */}
      <div className="hidden lg:block w-[28%] h-full relative">
        <img 
          src={RIGHT_IMAGE}
          alt="Park City Chiefs Player"
          className="w-full h-full object-cover"
          data-testid="cover-right-image"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#0a1628]/80" />
      </div>

      {/* Mobile background gradient (shows on small screens where side images are hidden) */}
      <div className="lg:hidden absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628] via-[#0a1628]/95 to-[#0a1628]" />
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.8s ease-out both;
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out both;
        }
      `}</style>
    </div>
  );
};

export default CoverPage;
